// extracted by mini-css-extract-plugin
module.exports = {"root":"Block_root__2p1V5","numbers":"Block_numbers__30CUj","title":"Block_title__i8hBO"};